import LinkContainer from "./LinkContainer";

export default function SettingsConfig({ currentWiidth }: any) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <LinkContainer currentWiidth={currentWiidth} />
    </div>
  );
}
